<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import PBIReport from '@components/pbi-report.vue'
import Cookies from 'js-cookie'
import pbiService from '@services/powerbi.js'

export default {
  components: { Layout, PBIReport },
  data() {
    return {
      reportId: [process.env.VUE_APP_REPORT_ID_BIOSTIM],
    }
  },
  page: {
    title: 'BGT',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  computed: {
    embedInfo() {
      //  return this.$store.getters['users/embedInfo']
      if (this.$store.getters['users/embedInfo']) {
        return this.$store.getters['users/embedInfo']
      } else {
        var embedInfo = JSON.parse(localStorage.getItem('embed_info'))
        return {
          token: embedInfo.embedToken.token,
          embedReports: embedInfo.embedReport,
          expiration: embedInfo.embedToken.expiration,
        }
      }
    },
    userRoles() {
      if (this.$store.getters['users/userRoles']) {
        return this.$store.getters['users/userRoles']
      } else return Cookies.get('userRoles')
    },
    userRepNum() {
      return this.$store.getters['users/userRepNum']
    },
  },
  async mounted() {
    if (!this.embedInfo.token) {
      await pbiService.getEmbedInfo()
    }
  },
  methods: {},
}
</script>

<template>
  <Layout>
    <div class="h-100">
      <div class="h-100">
        <PBIReport v-if="embedInfo.token" :report-id="reportId"> </PBIReport>
      </div>
    </div>
  </Layout>
</template>
